var map = {
	"./": [
		"8hXn",
		1,
		0
	],
	"./Home": [
		"j7e0",
		7
	],
	"./Home.vue": [
		"j7e0",
		7
	],
	"./contact": [
		"a4yk",
		2
	],
	"./contact.vue": [
		"a4yk",
		2
	],
	"./index": [
		"8hXn",
		1,
		0
	],
	"./index.vue": [
		"8hXn",
		1,
		0
	],
	"./info": [
		"iNA+",
		9
	],
	"./info.vue": [
		"iNA+",
		9
	],
	"./news": [
		"uxuc",
		0,
		3
	],
	"./news.vue": [
		"uxuc",
		0,
		3
	],
	"./partner": [
		"FarA",
		5
	],
	"./partner.vue": [
		"FarA",
		5
	],
	"./patent": [
		"IjaV",
		4
	],
	"./patent.vue": [
		"IjaV",
		4
	],
	"./product": [
		"pGxt",
		0,
		6
	],
	"./product.vue": [
		"pGxt",
		0,
		6
	],
	"./search": [
		"2QH8",
		0,
		8
	],
	"./search.vue": [
		"2QH8",
		0,
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*$
// module id = MWF8
// module chunks = 12